__turbopack_context__.v({
  "detailMenuContainer": "media-view-shared-module__kAKCga__detailMenuContainer",
  "imageMetaContainer": "media-view-shared-module__kAKCga__imageMetaContainer",
  "imageZoomOnHover": "media-view-shared-module__kAKCga__imageZoomOnHover",
  "squaredButton": "media-view-shared-module__kAKCga__squaredButton",
});
